module.exports = __webpack_public_path__ + "static/media/thumb_up_black47a72571.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/thumb_up_black.svg
// module id = 176
// module chunks = 0